import { ArrowLeft } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Card } from "../../components/ui/card";
import { useNavigate } from "react-router-dom";
import welcomeBg from "../../assets/homebg.png";

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="scrollbar-hide relative mx-auto w-full max-w-[400px] bg-background"
      style={{
        minHeight: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Blurred Background Image */}
      <div
        className="absolute inset-0 scale-105 bg-cover bg-center bg-no-repeat blur-md"
        style={{
          backgroundImage: `url(${welcomeBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-background/80" />

      <div
        className="scrollbar-hide relative z-10 space-y-5 overflow-y-auto p-4 pb-20"
        style={{ height: "calc(100vh - 0px)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-4 pt-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
            className="rounded-xl bg-card/80 shadow-md hover:bg-card"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold text-foreground">
            Terms of Service
          </h1>
        </div>

        {/* Content Card */}
        <Card className="space-y-5 rounded-2xl border border-border bg-card p-6 shadow-lg">
          {/* Last Updated */}
          <p className="text-xs italic text-muted-foreground">
            Last updated: December 2025
          </p>

          <div className="pt-2">
            <h3 className="mb-2 text-base font-bold text-foreground">
              Acceptance of Terms
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              By accessing and using Bite Balance, you accept and agree to be
              bound by these Terms of Service. If you do not agree to these
              terms, please do not use our application.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Use of Service
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              Bite Balance provides health and nutrition tracking tools for
              personal, non-commercial use. You agree to use the service
              responsibly and in accordance with all applicable laws.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              User Accounts
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              You are responsible for maintaining the confidentiality of your
              account credentials and for all activities that occur under your
              account.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Health Disclaimer
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              Bite Balance is not a substitute for professional medical advice,
              diagnosis, or treatment. Always consult with a qualified
              healthcare provider before making any health-related decisions.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Intellectual Property
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              All content, features, and functionality of Bite Balance are owned
              by us and are protected by international copyright, trademark, and
              other intellectual property laws.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Limitation of Liability
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              Bite Balance shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages resulting from your
              use of or inability to use the service.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Changes to Terms
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              We reserve the right to modify these terms at any time. Continued
              use of the service after changes constitutes acceptance of the new
              terms.
            </p>
          </div>

          <div>
            <h3 className="mb-2 text-base font-bold text-foreground">
              Contact Us
            </h3>
            <p className="text-sm leading-relaxed text-blue-600">
              If you have any questions about these Terms of Service, please
              contact us at{" "}
              <span className="font-semibold">legal@bitebalance.com</span>
            </p>
          </div>
        </Card>

        {/* Footer */}
        <p className="text-center text-xs text-muted-foreground/70">
          © 2026 Bite Balance. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
